import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import login from './loginform';
import intlLogin from './intlLoginform';
import candidateLoginForm from './candidateLoginForm.reducer';
import portal from './portal';
import verification from './verificationform';
import verifications from './verifications';
import privacy from './privacy.reducer';

export const appBreakpoints = {
  extraSmall: 576,
  small: 768,
  medium: 992,
  large: 1200,
};

const rootReducer = combineReducers({
  privacy,
  form: form.plugin({ login, intlLogin, verification, candidateLoginForm }),
  portal,
  verifications,
});

export default rootReducer;
